// @flow

/**
 * usersTimeline.js - Редюсер для изменения данных о количестве пользователей в течение дня в хранилище
 * @module reducers/usersTimeline
 * @requires module:constants/UsersTimeline
 * */

import {LOCATION_CHANGE} from 'react-router-redux'

import {
    SET_USERS
} from '../constants/UsersTimeline'

/**
 * @memberof reducers/usersTimeline
 * */
type Timeline = {
    date: string,
    today: number,
    weekAgo: number,
}

/**
 * @memberof reducers/usersTimeline
 * */
type State = {
    timeline: Timeline[],
}

/**
 * @memberof reducers/usersTimeline
 * */
type Action = {
    type: string,
    timeline: Timeline[],
}

/**
 * Начальное состояние
 * @memberof reducers/usersTimeline
 * */
export const initialState: State = {
    timeline: [],
}

/**
 * Возвращает новое состояние с количеством пользователей за день
 * @memberof reducers/usersTimeline
 * @function usersTimeline
 * @param {State} state
 * @param {Action} action
 * @return {State}
 * */
export default function usersTimeline(state: State = initialState, action: Action): State {
    switch (action.type) {
        case SET_USERS:
            return {...state, timeline: [...action.timeline]}
            
        case LOCATION_CHANGE:
            return {...initialState}
        
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/usersTimeline.js